import { render, staticRenderFns } from "./NavMenuSection.vue?vue&type=template&id=f346bce0&scoped=true"
import script from "./NavMenuSection.vue?vue&type=script&lang=js"
export * from "./NavMenuSection.vue?vue&type=script&lang=js"
import style0 from "./NavMenuSection.vue?vue&type=style&index=0&id=f346bce0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f346bce0",
  null
  
)

export default component.exports